export const DEFAULT_ERROR_MESSAGE =
  "Some thing went wrong, Please try again after sometime";

  export const CURRENCY_CODES = [
  { value: "USD", symbol: "$" }, // US Dollar
  { value: "EUR", symbol: "€" }, // Euro
  { value: "INR", symbol: "₹" }, // Indian Rupee
  { value: "GBP", symbol: "£" }, // British Pound Sterling
  { value: "JPY", symbol: "¥" }, // Japanese Yen
  { value: "AUD", symbol: "A$" }, // Australian Dollar
  { value: "CAD", symbol: "C$" }, // Canadian Dollar
  { value: "SGD", symbol: "S$" }, // Singapore Dollar
  { value: "CHF", symbol: "CHF" }, // Swiss Franc
  { value: "CNY", symbol: "¥" }, // Chinese Yuan
  { value: "AED", symbol: "د.إ" }, // UAE Dirham
  { value: "BRL", symbol: "R$" }, // Brazilian Real
  { value: "MXN", symbol: "$" }, // Mexican Peso
  { value: "NZD", symbol: "NZ$" }, // New Zealand Dollar
  { value: "ZAR", symbol: "R" }, // South African Rand
  { value: "KRW", symbol: "₩" }, // South Korean Won
  { value: "RUB", symbol: "₽" }, // Russian Ruble
  { value: "HKD", symbol: "HK$" }, // Hong Kong Dollar
  { value: "SEK", symbol: "kr" }, // Swedish Krona
  { value: "NOK", symbol: "kr" }, // Norwegian Krone
  { value: "DKK", symbol: "kr" }, // Danish Krone
  { value: "MYR", symbol: "RM" }, // Malaysian Ringgit
  { value: "THB", symbol: "฿" }, // Thai Baht
  { value: "IDR", symbol: "Rp" }, // Indonesian Rupiah
  { value: "PHP", symbol: "₱" }, // Philippine Peso
  { value: "PKR", symbol: "₨" }, // Pakistani Rupee
];



  
// export const CURRENCY_CODES = [
//   {
//     value: "AED",
//     label: "د.إ",
//   },
//   {
//     value: "AFN",
//     label: "؋",
//   },
//   {
//     value: "ALL",
//     label: "L",
//   },
//   {
//     value: "INR",
//     label: "₹",
//   },
// ];


// export const CURRENCY_CODES = (() => {
//   const currencies = [
//     "AED", "AFN", "ALL", "INR", "USD", "EUR", "GBP", "JPY", "CAD", "AUD", 
//     "CNY", "SAR", "MXN", "RUB", "BRL", "ZAR", "DKK", "CHF", "SEK", "NZD", 
//     "SGD", "KRW", "PLN", "NOK", "TRY", "HUF", "CZK", "THB", "IDR", "MYR", 
//     "PHP", "EGP", "ILS", "VND", "COP", "KES", "TZS", "UGX", "UGS", "GHS"
//     // Add more currency codes as needed
//   ];

//   return currencies.map((currency) => {
//     const symbol = new Intl.NumberFormat("en-US", {
//       style: "currency",
//       currency,
//     }).formatToParts().find((part) => part.type === "currency")?.value || currency;
    
//     return {
//       value: currency,
//       label: symbol,
//     };
//   });
// })();


export const interview_types = {
  assessment: "Master Your Interview",
  big_5: "AI Persona Check",
  dynamic: "Dynamic AI Interview"
};